<template>  
  <table class="permissions" :class="dark_t?'dark':''">
    <thead>
      <tr>
        <th class="width200px">Perfil</th>
        <th>Permisos dentro de la plataforma</th>
        <th class="width200px">Cantidad de Usuarios</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(v, i) in profiles" :key="i">
        <td>{{v.profile_name}}</td>
        <td>{{v.permissions}}</td>
        <td>{{v.users}}</td>
      </tr>
    </tbody>
  </table>
	
	
</template>

<script>
export default {
  data() {
    return {
      profiles:[],
    };
  },
  created(){
    this.requests.gets['dashboard/user_profile_summary']({is_deleted:false})
      .then(r => this.dev_log({r})||( this.profiles = r));
  },
};
</script>

<style scoped>
.permissions {
  border-spacing: 0;
  border-collapse: collapse;
  border: solid #707070 2px;
  width: 100%;
}
.permissions thead{
  background-color: #ededed;
}
.permissions.dark thead{
  background-color: black;
}
.permissions thead th,
.permissions tbody td{
  text-align: left;
  padding: 5px;
  border: solid 2px #707070;
}
.permissions tbody td:nth-of-type(3){
  text-align: right;
  padding-right: 10px;
}
</style>
